export default "__VITE_ASSET__DxDQA4e1__"